import { useParams } from 'react-router-dom';

export const useServiceId = () => useParams<Dictionary<string>>().id!;
